import { wait } from '../wait'

export const onWindowResize = (func: (width?: number, height?: number) => void) => {
    window.addEventListener('resize', () => {
        wait(100)
            .then(() => {
                func(window.outerWidth, window.outerHeight)
            })
            .catch(_ => {})
    })
}
